import { render, staticRenderFns } from "./HeaderInformationNavigationEdunetke.vue?vue&type=template&id=dc0270ce&scoped=true"
import script from "./HeaderInformationNavigationEdunetke.vue?vue&type=script&lang=ts"
export * from "./HeaderInformationNavigationEdunetke.vue?vue&type=script&lang=ts"
import style0 from "./HeaderInformationNavigationEdunetke.vue?vue&type=style&index=0&id=dc0270ce&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dc0270ce",
  null
  
)

export default component.exports